import React from "react";
import UseContext from "../../hooks/useContext";
import useModal from "../modal/useModal";
import { SettingRow } from "../settings/SettingRow";

function BreaksBlock({ breaks, isWaiting, onCommitBreaks }) {
  const { setModalData } = UseContext();
  const { toggle } = useModal();
  const checkedBreak = breaks.find((b) => b.checked);

  const openModal = () => {
    setModalData({
      block: "breaks",
      breaks,
      isWaiting,
      commitBreaks: onCommitBreaks,
      modalSessionKey: Date.now(),
    });
    toggle("settings_edit_block");
  };

  const description = isWaiting ? (
    <div className="space-y-2">
      <div className="h-4 max-w-lg animate-pulse rounded bg-gray-200" />
      <div className="h-4 max-w-md animate-pulse rounded bg-gray-200" />
    </div>
  ) : (
    checkedBreak?.desc || "—"
  );

  return (
    <SettingRow
      title="Pauses dans le fichier Peopulse"
      description={description}
      onEdit={openModal}
    />
  );
}

export default BreaksBlock;
